import STATE from './state';

import { createStore } from '@harlem/core';

const NAME = 'auth';

export const { state, getter, mutation } = createStore(NAME, STATE);
